export default () => ({
  dialogContent: {
    padding: 0,
    position: 'relative',
    minHeight: 400,
  },
})
